/**
 * window.localStorage
 * key 'token'
 * */

export function getToken() {
	return window.localStorage.getItem('zhongbiao_token');
}

export function setToken(token) {
	return window.localStorage.setItem('zhongbiao_token', token);
}

export function removeToken() {
	return window.localStorage.removeItem('zhongbiao_token');
}



// WEBPACK FOOTER //
// ./src/utils/auth.js